import { ThemeColors } from '~/themes/colors'

export interface DoNotDisturbSplitButtonColors {
  BackgroundColor: ThemeColors
  HoverBackgroundColor: ThemeColors
  ActiveBackgroundColor: ThemeColors
  OnBackgroundColor: ThemeColors
  OnHoverBackgroundColor: ThemeColors
  OnActiveBackgroundColor: ThemeColors
  TextColor: ThemeColors
  OnTextColor: ThemeColors
  ReceivingCallsIconColor: ThemeColors
}

export const doNotDisturbSplitButtonColors: DoNotDisturbSplitButtonColors = {
  BackgroundColor: {
    default: 'gray.400',
  },
  HoverBackgroundColor: {
    default: 'gray.500',
  },
  ActiveBackgroundColor: {
    default: 'gray.600',
  },
  OnBackgroundColor: {
    default: 'red.800',
  },
  OnHoverBackgroundColor: {
    default: 'red.700',
  },
  OnActiveBackgroundColor: {
    default: 'red.900',
  },
  TextColor: {
    default: 'gray.1300',
  },
  OnTextColor: {
    default: 'white',
  },
  ReceivingCallsIconColor: {
    default: 'green.700',
  },
}
